"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SkipToContent_styled_exports = {};
__export(SkipToContent_styled_exports, {
  StyledLink: () => StyledLink,
  StyledSpan: () => StyledSpan
});
module.exports = __toCommonJS(SkipToContent_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Link = require("../Link/Link.component");
var getPlacement = function getPlacement2(placement) {
  switch (placement) {
    case "top-right":
      return (0, import_styled_components.css)(["top:5px;right:56px;left:auto;"]);
    case "bottom-left":
      return (0, import_styled_components.css)(["bottom:5px;left:56px;top:auto;"]);
    case "bottom-right":
      return (0, import_styled_components.css)(["bottom:5px;right:56px;left:auto;top:auto;"]);
    default:
      return (0, import_styled_components.css)(["top:5px;left:56px;"]);
  }
};
var StyledLink = (0, import_styled_components.default)(import_Link.Link).withConfig({
  displayName: "SkipToContentstyled__StyledLink",
  componentId: "sc-1wa7p9x-0"
})(function(_ref) {
  var theme = _ref.theme, placement = _ref.placement, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? "auto" : _ref$zIndex;
  return (0, import_styled_components.css)(["position:absolute;top:-50px;left:-150px;padding:8px 16px;", ";", ";background-color:", ";color:", " !important;z-index:", ";margin-top:", ";&::after{position:absolute;top:-3px;left:-3px;inset:-0.1875rem;display:none;content:'';", ";box-shadow:", " 0px 0px 0px 1px;}&:focus{outline:none;", ";&::after{display:block;}}"], (0, import_mixins.withBorder)(theme.colors.beige[180]), (0, import_mixins.withBorderRadius)(), theme.colors.white, theme.colors.n[100], zIndex, theme.measurements.extraSmall, (0, import_mixins.withBorderRadius)(), theme.colors.beige[180], getPlacement(placement));
});
var StyledSpan = import_styled_components.default.span.withConfig({
  displayName: "SkipToContentstyled__StyledSpan",
  componentId: "sc-1wa7p9x-1"
})(["position:absolute;"]);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledLink,
  StyledSpan
});
//# sourceMappingURL=SkipToContent.styled.js.map